// src/views/CompaniaDinamica.js
import React, { useMemo, useState } from "react";
import VisualizacionBomberos from "../components/VisualizacionBomberos";
import MenuLateralBombero from "../components/MenuLateralBombero";
import TextBannerUnderLogo from "../components/TextBannerUnderLogo";

export default function CompaniaDinamica({ compania }) {
  const [mostrarMenu, setMostrarMenu] = useState(false);
  const [citaciones, setCitaciones] = useState(0);

  const offsetTop = useMemo(
    () => 70 + (Number.isFinite(citaciones) ? citaciones : 0) * 48,
    [citaciones]
  );

  return (
    <div>
      <button
        onClick={() => setMostrarMenu((prev) => !prev)}
        style={{
          position: "fixed",
          top: 10,
          left: 10,
          zIndex: 2500,
          padding: "6px 10px",
        }}
      >
        ☰ Menú
      </button>

      {mostrarMenu && (
        <MenuLateralBombero onClose={() => setMostrarMenu(false)} />
      )}

      <div
        style={{
          marginTop: offsetTop,
          width: "100%",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 6,
        }}
      >
        {compania.logoResuelto ? (
          <img
            src={compania.logoResuelto}
            alt={`Logo ${compania.nombre}`}
            style={{
              maxWidth: "280px",
              width: "min(40vw, 280px)",
              height: "auto",
              display: "block",
            }}
          />
        ) : null}

        <TextBannerUnderLogo cia={compania.nombre} />
      </div>

      <VisualizacionBomberos
        companiaFiltro={compania.nombre}
        onCitacionesChange={(cantidad) =>
          setCitaciones(Number.isFinite(cantidad) ? cantidad : 0)
        }
      />
    </div>
  );
}
